module.exports = __webpack_public_path__ + "img/swipe.603bb285.gif";